<template>
  <view-wrapper
    name="Profile"
    :showCancel="true"
    :saveFunc="saveChanges"
    :validation="validation"
    addedText="Save"
    :loading="loading"
    :loadingText="loadingText"
  >
    <wrapper class="mb-5">
      <div>
        <h3 class="text-lg">Name</h3>
        <p class="description">{{ user.firstname }} {{ user.lastname }}</p>
      </div>
      <div>
        <h3 class="text-lg">Email adress</h3>
        <p class="description">{{ user.sub }}</p>
      </div>
      <div>
        <h3 class="text-lg">Roles</h3>
        <div class="roles" v-for="role in roles" :key="role">
          <p class="description">{{ role }},</p>
        </div>
      </div>
      <div>
        <h3 class="text-lg">Groups</h3>
        <div class="roles" v-for="group in groups" :key="group">
          <p class="description">{{ group }},</p>
        </div>
      </div>
      <div>
        <h3 class="text-lg">Permissions</h3>
        <div
          class="permissions"
          v-for="permission in permissions"
          :key="permission"
        >
          <span>
            <p class="description">{{ permission }},</p></span
          >
        </div>
      </div>
    </wrapper>
    <wrapper class="mb-5" :v-if="defaultGroupOptions">
      <div class="w-1/2">
        <p>Default group</p>
        <div class="flex">
          <drop-down
            class="flex-1 w-full mr-2"
            placeholder="Select default group"
            :value="defaultGroup"
            valueProperty="groupName"
            searchProp="groupName"
            :options="defaultGroupOptions"
            @input="updateDefaultGroup($event)"
          >
            {{ defaultGroup.groupName }}
          </drop-down>
        </div>
      </div>
      <div class="w-1/2">
        <p>Default printer</p>
        <div class="flex">
          <drop-down
            class="flex-1 w-full mr-2"
            placeholder="Select default printer"
            :value="defaultPrinter"
            valueProperty="name"
            searchProp="name"
            :options="defaultPrinterOptions"
            @input="updateDefaultPrinter($event)"
          >
            {{ defaultPrinter.name }}
          </drop-down>
        </div>
      </div>
    </wrapper>

    <api-key-zone />

    <wrapper class="mb-5">
      <div class="p-6">
        <div class="pb-4">
          <p class="text-left">Change your password</p>
          <password-rules-hint class="pt-2" />
        </div>
        <div class="w-1/2">
          <vInput
            ref="currentpassword"
            :labelPlaceholder="'Enter current password'"
            :type="'password'"
            v-model="currentpassword"
            :editable="true"
          />
          <vInput
            ref="newpassword"
            :labelPlaceholder="'Enter new password'"
            :type="'password'"
            :error="newPasswordRulesError"
            v-model="newpassword"
            :editable="true"
          />
          <vInput
            ref="confirmpassword"
            :labelPlaceholder="'Confirm new password'"
            :type="'password'"
            :error="passwordError"
            v-model="confirmpassword"
            :editable="true"
          />
        </div>
      </div>
    </wrapper>
  </view-wrapper>
</template>

<script>
import vInput from "components/forms/Input.vue";
import DropDown from "components/forms/DropDown.vue";
import PasswordRulesHint from "components/PasswordRulesHint.vue";
import ApiKeyZone from "components/ApiKeyZone.vue";
import { validatePassword } from "@/utils/passwordRules";

export default {
  name: "settings",
  components: {
    vInput,
    DropDown,
    PasswordRulesHint,
    ApiKeyZone
  },
  data() {
    return {
      loading: false,
      loadingText: "User settings",
      firstname: "",
      lastname: "",
      currentpassword: "",
      newpassword: "",
      confirmpassword: "",
      user: {},
      groups: [],
      roles: [],
      permissions: [],
      userSettings: {
        defaultGroupId: null,
        defaultPrinterId: null
      },
      defaultGroupOptions: [],
      defaultPrinterOptions: []
    };
  },
  methods: {
    async saveChanges() {
      this.loading = true;
      const payload = {
        userId: this.user.id,
        currentPassword: this.currentpassword,
        newPassword: this.newpassword
      };
      try {
        await this.$store.dispatch("AUTH/PASSWORD", payload);
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    async getData() {
      this.user = this.$store.getters["AUTH/AUTH_GET_USER"];
      this.firstname = this.user.firstname;
      this.lastname = this.user.lastname;
      this.roles = this.user.UserRole;
      this.permissions = [...new Set(this.user.UserPermission)];
      await this.$store.dispatch("ROLES/GET");
      await this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");
      await this.$store.dispatch("PREFERENCES/GET_USER_SETTINGS");
      await this.$store.dispatch("PRINTERS/GET_INSTALLED_PRINTERS");

      const groups = this.$store.getters["GROUPS/GROUPS"];
      const printers = this.$store.getters["PRINTERS/INSTALLED_PRINTERS"];

      if (this.user.Group) {
        this.defaultGroupOptions = groups.filter(x =>
          this.user.Group.includes(x.id.toString())
        );
      }

      this.defaultPrinterOptions = printers.filter(x =>
        x.groups
          .map(g => g.id)
          .some(groupId =>
            this.defaultGroupOptions.map(x => x.id).includes(groupId)
          )
      );

      this.userSettings = this.$store.getters["PREFERENCES/USER_SETTINGS"];
      this.groups = this.defaultGroupOptions.map(x => x.groupName);
      this.loading = false;
    },
    async updateDefaultGroup(input) {
      this.loading = true;
      this.userSettings.defaultGroupId = input.id;
      try {
        await this.$store.dispatch(
          "PREFERENCES/SET_USER_SETTINGS",
          this.userSettings
        );
      } catch (error) {
        throw error;
      }
      this.loading = false;
    },
    async updateDefaultPrinter(input) {
      this.loading = true;
      this.userSettings.defaultPrinterId = input.id;
      try {
        await this.$store.dispatch(
          "PREFERENCES/SET_USER_SETTINGS",
          this.userSettings
        );
      } catch (error) {
        throw error;
      }
      this.loading = false;
    },
    validation() {
      return (
        this.currentpassword.length > 0 &&
        this.newpassword.length > 0 &&
        this.confirmpassword.length > 0 &&
        this.newPasswordRulesError == null &&
        this.passwordError == null
      );
    }
  },
  async mounted() {
    this.loading = true;
    await this.getData();
  },
  computed: {
    defaultGroup() {
      const defaultGroupId = this.userSettings.defaultGroupId;
      const group = this.defaultGroupOptions.find(x => x.id === defaultGroupId);
      return group || {};
    },
    defaultPrinter() {
      const defaultPrinterId = this.userSettings.defaultPrinterId;
      const printer = this.defaultPrinterOptions.find(
        x => x.id === defaultPrinterId
      );

      return printer || {};
    },
    newPasswordRulesError() {
      if (!this.newpassword || this.newpassword.length === 0) return null;
      const result = validatePassword(this.newpassword);
      return result.valid ? null : result.message;
    },
    passwordError() {
      return this.newpassword.length > 0 &&
        this.newpassword != this.confirmpassword
        ? "Confirm password does not match new password"
        : null;
    }
  }
};
</script>

<style scoped>
.description {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  font-size: 12px;
  display: inline;
}
.permissions {
  display: inline-block;
  margin: auto;
}
.roles {
  display: inline-block;
  margin: auto;
}
</style>
